import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useFetchContent = (isRecipes, productId, transformData) => {
  const location = useLocation();
  const [contentSections, setContentSections] = useState(null);
  const [isLoading, setIsLoading] = useState(!!location.pathname.split('/')[2]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!productId) {
      setContentSections(null);
      return;
    }

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `/api/google-sheets?isRecipes=${isRecipes}&productId=${productId}`
        );

        if (!response.ok) {
          console.error('Error fetching data:', response.statusText);
        }

        const data = await response.json();
        if (data.values && data.values[0]) {
          setContentSections(transformData(data.values[0]));
        } else {
          setError(isRecipes ? 'Nie znaleziono przepisu' : 'Nie znaleziono produktu');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [isRecipes, productId]);

  return { contentSections, isLoading, error, setError };
};

export default useFetchContent;